import EntityForm from "@/mixins/EntityForm";
import Component, { mixins } from "vue-class-component";

@Component({
  inject: {
    languageService: "languageService",
    eventService: "eventService"
  }
})
export default class AuditoriumForm extends mixins(EntityForm) {
  model = {};
  internal_events = [];

  get elements() {
    return [
      {
        id: "code",
        label: this.translations.labels.auditorium_form_code,
        type: "text",
        required: true,
        rules: "min:4"
      },
      {
        id: "idEvent",
        label: this.translations.labels.events,
        type: "select",
        items: this.events,
        required: true
      },
      {
        id: "availableToGuests",
        label: this.translations.labels.auditorium_form_availableToGuests,
        type: "checkbox",
        required: false
      },
      {
        id: "hasVideoBox",
        label: this.translations.labels.auditorium_form_hasVideoBox,
        type: "checkbox",
        required: false
      },
      {
        id: "localizations",
        type: "localizations",
        header: this.translations.labels.form_localizations,
        languages: this.languages,
        resetColumns: true,
        elements: [
          {
            id: "name",
            label: this.translations.labels.auditorium_form_name,
            type: "text",
            required: true
          },
          {
            id: "imageUri",
            label: this.translations.labels.auditorium_form_backgroundImage,
            type: "media",
            mediaType: "background",
            required: true
          },
          {
            id: "videoBoxPosX",
            label: this.translations.labels.auditorium_form_videoBoxPositionX,
            type: "number",
            rules: "min:0|max:100",
            hint: this.translations.labels.auditorium_form_perc_hint,
            hide: this.hideVideoBox
          },
          {
            id: "videoBoxPosY",
            label: this.translations.labels.auditorium_form_videoBoxPositionY,
            type: "number",
            rules: "min:0|max:100",
            hint: this.translations.labels.auditorium_form_perc_hint,
            hide: this.hideVideoBox
          },
          {
            id: "videoBoxWidth",
            label: this.translations.labels.auditorium_form_videoBoxWidth,
            type: "number",
            rules: "min:0|max:100",
            hint: this.translations.labels.auditorium_form_perc_hint,
            hide: this.hideVideoBox
          },
          {
            id: "videoBoxHeight",
            label: this.translations.labels.auditorium_form_videoBoxHeight,
            type: "number",
            rules: "min:0|max:100",
            hint: this.translations.labels.auditorium_form_perc_hint,
            hide: this.hideVideoBox
          },
          //TODO: Remove
          {
            id: "infoboxTitle",
            label: this.translations.labels.auditorium_form_infoboxTitle,
            type: "text",
            rules: "max:255"
          },
          {
            id: "infoboxDescription",
            label: this.translations.labels.auditorium_form_infoboxDescription,
            type: "wysiwyg"
          }
        ],
      },
    ];
  }

  get event () {
    const _event = this.internal_events.filter(
      (e) => {
        return e.id == this.model.idEvent;
      }
    );
    if (_event.length > 0) {
      return _event[0];
    }
    return null;
  }

  get events() {
    return this.internal_events.map((i) => {
      return {
        languages: i.languages,
        label: i.code,
        value: i.id,
      };
    });
  }

  get languages() {
    if (
      this.model.idEvent === undefined ||
      this.model.idEvent === null ||
      this.events === undefined ||
      this.events === null
    )
      return [];
    const event = this.events.filter((e) => e.value == this.model.idEvent)[0];
    if (event != undefined) return event.languages;
    return [];
  }

  get helpLink() {
    return this.translations.pageHelp.auditorium;
  }

  hideVideoBox () {
    return !this.model.hasVideoBox;
  }

  // eslint-disable-next-line no-empty-function
  afterCreate () {
  }

  async created() {
    this.internal_events = await this.eventService.list();
    this.model.event = this.events.filter(
      (e) => e.value == this.model.idEvent
    )[0];

    this.afterCreate();
  }
}
